<div class="tw-flex tw-w-full tw-h-full tw-flex-col tw-items-stretch tw-place-content-stretch tw-place-items-stretch tw-gap-4">

    <div class="page-content tw-w-full tw-h-full">

        <div class="page tw-relative tw-flex tw-flex-col tw-justify-start tw-items-stretch tw-w-full tw-h-full"
            [ngStyle]="style">

            <span *ngIf="showHeader" class="page-header product-info tw-place-content-between tw-pr-4">
                <section class="tw-flex tw-basis-full tw-space-x-2 tw-justify-start tw-items-center">

                    <h1 class="page-title">
                        <ng-container *ngIf="iconTemplate; else defaultIconTemplate" [ngTemplateOutlet]="iconTemplate"></ng-container>

                        <span>
                            {{pageTitle}}

                            <ng-container *ngIf="extraTitleTemplate; else defaultExtraTitleTemplate"
                                [ngTemplateOutlet]="extraTitleTemplate"></ng-container>

                        </span>
                    </h1>
                </section>


                <section fxFlex class="page-actions" *ngIf="!this.hideOptions">
                    <section class="header-actions-wrapper" fxFlex fxLayout="row" fxLayoutAlign="end center"
                        fxLayoutGap="15px">

                        <ng-container *ngIf="!this.hideDashboardButton">
                            <button pButton pRipple fxFlexOrder="99" [routerLink]="backLink || ['../dashboard']"
                                class="p-button-rounded p-button-icon-only"
                                [pTooltip]="backLinkTooltip || 'Go to dashboard'" tooltipPosition="top"
                                icon="fal fa-tachometer-alt"></button>
                        </ng-container>
                        <section fxFlex fxLayout="row" fxFlexAlign="stretch center" fxLayoutGap="20px">

                            <ng-container *ngIf="
                                navigationOptionsTemplate;
                                else defaultNavigationOptionsTemplate" [ngTemplateOutlet]="navigationOptionsTemplate">
                            </ng-container>

                            <ng-container *ngIf="
                                        headerActionsTemplate;
                                        else defaultHeaderActionsTemplate
                                    " [ngTemplateOutlet]="headerActionsTemplate"></ng-container>
                        </section>
                    </section>
                </section>

            </span>

            <section class="product-details tw-relative tw-flex tw-flex-100 tw-flex-col tw-mr-3"
                fxLayoutAlign="stretch stretch">
                <div style="clear:both ;position: absolute;top:0;bottom:0;left:0;right:0;" fxLayout="column"
                    fxFlex="100%" fxLayoutAlign="stretch stretch" [ngSwitch]="activeView">

                    <ng-container *ngSwitchCase="'default'">
                        <ng-container *ngIf="contentTemplate" [ngTemplateOutlet]="contentTemplate">
                        </ng-container>

                    </ng-container>

                    <ng-template [ngSwitchCase]="'notifications'">
                        <section [@fadeInEnter] class="notifications-content">
                            <section fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px">

                                <p-messages [(value)]="this.notificationWrapper"></p-messages>


                                <!-- <ng-container
                                                *ngFor="let notification of notificationWrapper.notifications">
                                                <section fxFlex fxLayoutAlign="stretch start">
                                                    <p-message class="tw-flex row" severity="warn"
                                                        [text]="notification.description">
                                                    </p-message>
                                                </section>
                                            </ng-container> -->
                            </section>
                        </section>
                    </ng-template>


                </div>
            </section>

            <p-footer *ngIf="showFooter" fxFlex>
                <section class="no-flex" fxFlex fxLayoutAlign="end center">
                    <ng-container *ngIf="footerTemplate; else defaultFooterTemplate"
                        [ngTemplateOutlet]="footerTemplate">
                    </ng-container>
                </section>
            </p-footer>
        </div>
    </div>
</div>


<ng-template #defaultExtraTitleTemplate>
    {{appTitleService.currentRouteTitle}}
</ng-template>


<ng-template #defaultHeaderActionsTemplate>

</ng-template>

<ng-template #defaultNavigationOptionsTemplate>

</ng-template>

<ng-template #defaultIconTemplate>
    <em class="icon {{icon}}"></em>
</ng-template>


<ng-template #defaultFooterTemplate>

</ng-template>
